import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, map, of, tap } from "rxjs";
import { environment } from "../../environments/environment";
import { UserBasicProfile } from "../shared/models/user-basic-profile.mode";
import { StmxCommonCacheService, GroupFullInfo } from "ngx-exdr-stmx-common";

@Injectable({
  providedIn: "root"
})
export class GroupsService {
  constructor(
    private http: HttpClient,
    // private cacheService: StmxCommonCacheService,
  ) { }

  getGroupIdByDomain(doamin: string): Observable<string> {    
    const url = `${environment.apiHost}/api/reverselookup/CustomDomain?value=${doamin}`;    
    return this.http.get<string>(url);
  }

  /**
  * Gets UserBasicProfile from /api/user/basic by making HTTP call.
  *
  * @param groupsIds Group IDs to get group info.
  *
  * @returns Observable of UserBasicProfile
  */
  getUserGroupsProfiles(groupsIds: string[]): Observable<UserBasicProfile> {
    const url = `${environment.apiHost}/api/user/basic`;
    let headers = new HttpHeaders();

    const options = {
      headers: headers,
      params: new HttpParams({
        fromObject: {
          idenedis: groupsIds.join(",")
        }
      })
    };

    let request$: Observable<UserBasicProfile> = this.http.get<UserBasicProfile[]>(url, options).pipe(map((profiles) => (profiles?.length ? profiles[0] : null)));

    return request$;
  }

  /**
  * Gets GroupFullInfo from /api/user/${groupId} by making HTTP call.
  *
  * @param groupsId Group ID to get group full info.
  *
  * @returns Observable of group full information
  */
  
  getGroupInformation(groupId: string): Observable<GroupFullInfo | null> {
    const url = `${environment.apiHost}/api/user/${groupId}`;
    let request$: Observable<GroupFullInfo>;
    request$ = this.http.get<GroupFullInfo>(url).pipe(
      map((info) => {
        return info;
      })
    );
   
    return request$;
  }
  
}



